var render = function render(){var _vm=this,_c=_vm._self._c;return _c('react-wrapper',{style:({ height: '100%' }),attrs:{"component":_vm.subjectDoesNotExist}})
}
var staticRenderFns = []

export { render, staticRenderFns }